module.exports = __webpack_public_path__ + "img/new_banner_pt.2d68692f.jpg";